var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 16,
    viewBox: "0 0 23 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.65496 11.0752H10.5L11.8716 9.00019C12.0634 8.72104 12.322 8.49439 12.624 8.34096C12.9259 8.18753 13.2614 8.1122 13.6 8.12186H17.7483L13.5216 14.5002C13.3298 14.7792 13.0711 15.0056 12.7691 15.1587C12.4672 15.3119 12.1317 15.3869 11.7933 15.3769H6.35163L0.584961 7.72853L3.49996 3.33353C4.60496 1.66686 6.49996 0.700195 8.68329 0.700195H22.6666L20.3983 4.12686C20.2058 4.40569 19.9464 4.63174 19.6438 4.78432C19.3413 4.9369 19.0053 5.01112 18.6666 5.0002H7.66663L3.65496 11.0752Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.41389 6.08691C9.3858 6.57442 9.54133 7.05476 9.84983 7.43329C10.1583 7.81181 10.5974 8.06106 11.0806 8.13191C10.5321 8.23054 10.019 8.47128 9.59263 8.83012C9.16624 9.18895 8.84141 9.65333 8.65055 10.1769C8.67864 9.68941 8.52311 9.20907 8.21461 8.83054C7.90612 8.45202 7.46703 8.20277 6.98389 8.13191C7.53238 8.03329 8.04542 7.79255 8.47181 7.43371C8.8982 7.07488 9.22303 6.6105 9.41389 6.08691Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.9950cb0c55a0e18a01039333e726b4f6.svg";
export { ForwardRef as ReactComponent };